import React from 'react';
import { Info } from 'lucide-react';

/**
 * Honest placeholder for sidebar categories whose real controls are
 * genuinely item-scoped and already live in the Inspector panel (Effects,
 * Transitions) rather than fabricating a standalone browsing UI for them.
 */
export function EditorPlaceholderPanel({ icon: Icon = Info, title, body }) {
  return (
    <div className="flex flex-col items-center text-center px-4 py-10" data-testid="editor-tool-placeholder">
      <Icon className="h-7 w-7 text-[#555E6E] mb-3" />
      <p className="text-sm text-white font-medium mb-1">{title}</p>
      <p className="text-xs text-[#8A93A6] max-w-[220px]">{body}</p>
    </div>
  );
}
